import dayjs from 'dayjs/esm';
import duration from 'dayjs/esm/plugin/duration';
dayjs.extend(duration);

export const getDuration = (start: Date | number, end: Date | number): duration.Duration => {
  const startDay: dayjs.Dayjs = dayjs(start);
  const endDay: dayjs.Dayjs = dayjs(end).add(1, 'day');

  return dayjs.duration(endDay.diff(startDay));
};
